(() => {
  const boot = () => {
    const lineup = document.querySelector('[data-lineup]');
    if (lineup && !lineup.dataset.ready) {
      lineup.dataset.ready = 'true';
      const items = [...lineup.querySelectorAll('[data-item]')];
      let current = 3;
      const select = index => {
        current = Math.max(0, Math.min(items.length - 1, index));
        items.forEach((item, i) => {
          item.style.setProperty('--offset', i - current);
          item.classList.toggle('is-active', i === current);
          item.setAttribute('aria-pressed', String(i === current));
          item.tabIndex = Math.abs(i - current) <= 1 ? 0 : -1;
        });
        const chosen = items[current].dataset;
        document.querySelector('[data-lineup-title]').textContent = chosen.title;
        document.querySelector('[data-lineup-kind]').textContent = chosen.kind;
        document.querySelector('[data-lineup-price]').textContent = chosen.price;
        document.querySelector('[data-lineup-link]').href = chosen.url;
      };
      let down = null, dragged = false;
      lineup.addEventListener('pointerdown', e => { down = e.clientX; dragged = false; });
      lineup.addEventListener('pointerup', e => {
        if (down !== null && Math.abs(e.clientX - down) > 40) {
          select(current + (e.clientX < down ? 1 : -1)); dragged = true;
        }
        down = null;
      });
      lineup.addEventListener('pointercancel', () => { down = null; });
      items.forEach((item, i) => item.addEventListener('click', () => { if (!dragged) select(i); dragged = false; }));
      lineup.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); select(current + (e.key === 'ArrowRight' ? 1 : -1));
        }
      });
      select(current);
    }
    const choices = [...document.querySelectorAll('[data-gift]')];
    const panels = [...document.querySelectorAll('[data-gift-panel]')];
    const gift = i => {
      choices.forEach((choice, n) => { choice.classList.toggle('is-active', n === i); choice.setAttribute('aria-pressed', String(n === i)); });
      panels.forEach((panel, n) => { panel.hidden = n !== i; panel.classList.toggle('is-entering', n === i); });
    };
    choices.forEach((choice, i) => {
      if (choice.dataset.ready) return;
      choice.dataset.ready = 'true'; choice.setAttribute('role', 'button'); choice.setAttribute('aria-pressed', String(i === 0));
      choice.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) gift(i); });
      choice.addEventListener('focus', () => gift(i));
      choice.addEventListener('click', e => { e.preventDefault(); gift(i); });
      choice.addEventListener('keydown', e => { if (e.key === ' ') { e.preventDefault(); gift(i); } });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
          }
        });
      }, { threshold: .12 });
      document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el, i) => {
        el.style.setProperty('--reveal-delay', `${Math.min(i % 3, 2) * 70}ms`); observer.observe(el);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
